var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSponsors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9114_104947)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "url(#paint0_linear_9114_104947)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9114_104947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2065 9.06253C12.9877 7.47958 13.3784 6.68811 14 6.68811C14.6216 6.68811 15.0122 7.47958 15.7935 9.06253L16.0537 9.58989C16.2817 10.0518 16.3956 10.2827 16.5953 10.4278C16.795 10.5729 17.0499 10.6099 17.5596 10.684L18.1416 10.7685C19.8885 11.0224 20.7619 11.1493 20.954 11.7405C21.1461 12.3317 20.5141 12.9478 19.25 14.1799L18.8289 14.5904C18.4601 14.9499 18.2756 15.1297 18.1994 15.3644C18.1231 15.5992 18.1666 15.853 18.2537 16.3607L18.3531 16.9403C18.6515 18.6801 18.8007 19.55 18.2978 19.9154C17.7949 20.2808 17.0137 19.8701 15.4512 19.0487L14.9307 18.775C14.4748 18.5353 14.2468 18.4155 14 18.4155C13.7531 18.4155 13.5252 18.5353 13.0693 18.775L12.5488 19.0487C10.9863 19.8701 10.2051 20.2808 9.70217 19.9154C9.19927 19.55 9.34847 18.6801 9.64687 16.9403L9.74628 16.3607C9.83335 15.853 9.87688 15.5992 9.8006 15.3644C9.72432 15.1297 9.53991 14.9499 9.17109 14.5904L8.74997 14.1799C7.48591 12.9478 6.85388 12.3317 7.04598 11.7405C7.23807 11.1493 8.11151 11.0224 9.8584 10.7685L10.4404 10.684C10.9501 10.6099 11.2049 10.5729 11.4046 10.4278C11.6043 10.2827 11.7183 10.0518 11.9462 9.58989L12.2065 9.06253Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9114_104947",
    x1: 0,
    y1: 0,
    x2: 28,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64560"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9114_104947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9114_104947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsors);
export default __webpack_public_path__ + "static/media/sponsors.b2f1570d.svg";
export { ForwardRef as ReactComponent };